import { render, staticRenderFns } from "./sample-order-details.vue?vue&type=template&id=cc80f1f0&scoped=true"
import script from "./sample-order-details.vue?vue&type=script&lang=js"
export * from "./sample-order-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc80f1f0",
  null
  
)

export default component.exports